import {AbstractControl} from "@angular/forms";
import {Subscription} from "rxjs";

export class ControlLinker<T extends AbstractControl = AbstractControl> {
    links: Set<any> = new Set();
    subscriptions: Map<T, Subscription> = new Map<T, Subscription>();

    link(control: T): void {
        const options = { emitEvent: false };
        const subscription = control.valueChanges.subscribe(
            (value) => this.patchValue(value, options)
        );
        this.subscriptions.set(control, subscription);
        this.links.add(control);
    }

    unlink(control: T): void {
        this.subscriptions.get(control).unsubscribe();
        this.subscriptions.delete(control);
        this.links.delete(control);
    }

    patchValue(value: any, options?: any): void {
        this.links.forEach(
            (link) => link.patchValue(value, options)
        );
    }
}
